import { useAuthContext } from "../context/auth.context"

const useAuth = () => {
  return useAuthContext()
}

export { useAuth }